// extracted by mini-css-extract-plugin
export default {"back-icon":"back-button__back-icon___2bOyA","back-button":"back-button__back-button___38Ffd"};